import React, { useContext } from "react";
import { Button } from "@mui/material";
import CustomCard from "../../styleComp/CustomCard";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Divider from "@mui/material/Divider";
import imageUrl from "../../images/two2.png";
import { useUser } from "../../contexts/UserContext";

const HospitalNavCard = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const canCreate = user?.roles?.some(
    (r) => r.ChemoRecordsPage && r?.properties[0]?.ChemoRecords?.Creator === true
  );

  const buttonStyle = {
    width: "150px",
    height: "50px",
    color: "white",
    display: "block",
    border: "none",
  };

  const handleButtonHover = (event) => {
    event.target.style.color = "rgb(219, 217, 217)";
    event.target.style.backgroundColor = "#65b891";
  };

  const handleButtonLeave = (event) => {
    event.target.style.color = "white";
    event.target.style.backgroundColor = "#295c9a";
  };

  return (
    <CustomCard backgroundColorStyle={"rgb(41,91,154)"} heightCard={"100%"}>
      <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex", xl: "flex" }, flexDirection: "column" }}>
        <img src={imageUrl} alt="Sample" style={{ width: "15vh" }} />
        <Typography
          sx={{
            textAlign: "center",
            color: "#65b891",
            fontWeight: "bold",
            fontSize: "20px",
            marginTop: "-0.5rem",
            marginBottom: "0.6rem",
          }}
        >
          כימותרפיה
        </Typography>
        <Divider color="#3b82db" variant="middle" />

        <Button
          variant="outlined"
          style={buttonStyle}
          onClick={() => navigate("/portal")}
          onMouseEnter={handleButtonHover}
          onMouseLeave={handleButtonLeave}
        >
          דף הבית
        </Button>
        <Divider color="#3b82db" variant="middle" />

        {canCreate && (
          <>
            <Button
              variant="outlined"
              style={buttonStyle}
              onClick={() => navigate("/chemo?new=1")}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              דוח חדש
            </Button>
            <Divider color="#3b82db" variant="middle" />
          </>
        )}
      </Box>
    </CustomCard>
  );
};

export default HospitalNavCard;
